<div class="d-flex align-items-center justify-content-between mb-3">
  <h1 class="mb-0">Conference Applications</h1>
  <button type="button" class="btn btn-secondary btn-thin" (click)="load()">
    <i class="fas fa-sync-alt"></i> Refresh
  </button>
</div>

<ul class="nav nav-tabs mb-3">
  <li class="nav-item" *ngIf="canReview">
    <button type="button" class="nav-link" [class.active]="activeTab === 'review'" (click)="activeTab = 'review'">
      Review
    </button>
  </li>
  <li class="nav-item" *ngIf="canReview">
    <button type="button" class="nav-link" [class.active]="activeTab === 'post'" (click)="activeTab = 'post'">
      Post-Conference
    </button>
  </li>
  <li class="nav-item" *ngIf="canReview || canReport">
    <button type="button" class="nav-link" [class.active]="activeTab === 'history'" (click)="activeTab = 'history'">
      Employee History
    </button>
  </li>
  <li class="nav-item" *ngIf="canReport">
    <button type="button" class="nav-link" [class.active]="activeTab === 'report'" (click)="activeTab = 'report'; loadReport()">
      Report
    </button>
  </li>
</ul>

<div class="card" *ngIf="activeTab === 'review' && canReview">
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-md-3">
        <label for="conference-status-filter"><b>Status</b></label>
        <select id="conference-status-filter" class="form-control" [(ngModel)]="statusFilter">
          <option [ngValue]="null">All statuses</option>
          <option *ngFor="let status of statuses" [ngValue]="status.value">{{status.label}}</option>
        </select>
      </div>
      <div class="col-12 col-md-3 mt-2 mt-md-0">
        <label for="conference-name-filter"><b>Conference</b></label>
        <input id="conference-name-filter" class="form-control" [(ngModel)]="conferenceFilter" />
      </div>
      <div class="col-12 col-md-3 mt-2 mt-md-0">
        <label for="conference-role-filter"><b>Role Category</b></label>
        <input id="conference-role-filter" class="form-control" [(ngModel)]="roleFilter" />
      </div>
      <div class="col-12 col-md-3 mt-2 mt-md-0">
        <label for="conference-date-filter"><b>Submitted Date</b></label>
        <input id="conference-date-filter" type="date" class="form-control" [(ngModel)]="submittedDateFilter" />
      </div>
    </div>

    <div class="text-center p-4" *ngIf="loading">
      <i class="material-icons rotate text-muted">loop</i>
    </div>

    <div class="table-responsive mt-3" *ngIf="!loading">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Conference</th>
            <th>Level</th>
            <th>Role Category</th>
            <th>Submitted</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let application of filteredApplications">
            <td>{{application.employeeName}}</td>
            <td>{{application.conferenceTitle}}</td>
            <td>{{application.levelLabel}}</td>
            <td>{{application.eligibilitySnapshot?.roleCategoryName || 'Not assigned'}}</td>
            <td>{{application.submittedDate | date:'M/d/yy'}}</td>
            <td>
              {{application.statusLabel}}
              <span class="badge badge-warning ml-1" *ngIf="application.isException">Exception</span>
            </td>
            <td class="text-right">
              <button type="button" class="btn btn-primary btn-thin" (click)="openApplication(application)">
                Review
              </button>
            </td>
          </tr>
          <tr *ngIf="!filteredApplications.length">
            <td colspan="7" class="text-muted">No conference applications match these filters.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card" *ngIf="activeTab === 'post' && canReview">
  <div class="card-body">
    <h2>Post-Conference Tracking</h2>
    <p class="text-muted">Record whether each approved conference benefit was utilized. Saving an outcome releases the reservation and deducts only final utilized hours.</p>
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Conference</th>
            <th>Dates</th>
            <th>Reserved</th>
            <th>Outcome</th>
            <th>Hours Utilized</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let application of approvedApplications">
            <td>{{application.employeeName}}</td>
            <td>{{application.conferenceTitle}} ({{application.levelLabel}})</td>
            <td>{{application.conferenceStartDate | date:'M/d/yy'}} - {{application.conferenceEndDate | date:'M/d/yy'}}</td>
            <td>{{application.reservedHours | number:'1.2-2'}}</td>
            <td>{{application.utilizationStatusLabel || 'Pending'}}</td>
            <td>{{application.utilizedHours ?? 0 | number:'1.2-2'}}</td>
            <td class="text-right">
              <button type="button" class="btn btn-primary btn-thin" (click)="openUtilization(application)">
                {{application.utilizationStatusID ? 'Correct outcome' : 'Record outcome'}}
              </button>
            </td>
          </tr>
          <tr *ngIf="!approvedApplications.length">
            <td colspan="7" class="text-muted">There are no approved conference applications.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card" *ngIf="activeTab === 'history' && (canReview || canReport)">
  <div class="card-body">
    <h2>Employee Conference History</h2>
    <div class="row">
      <div class="col-12 col-md-6">
        <label for="conference-history-employee"><b>Employee</b></label>
        <select id="conference-history-employee" class="form-control" [(ngModel)]="historyUserID" (ngModelChange)="loadEmployeeHistory()">
          <option [ngValue]="null">Select an employee</option>
          <option *ngFor="let employee of historyEmployees" [ngValue]="employee.userID">{{employee.employeeName}}</option>
        </select>
      </div>
    </div>
    <div class="text-center p-4" *ngIf="historyLoading"><i class="material-icons rotate text-muted">loop</i></div>
    <div class="table-responsive mt-3" *ngIf="historyUserID && !historyLoading">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Conference</th>
            <th>Dates</th>
            <th>Level</th>
            <th>Decision</th>
            <th>Utilization</th>
            <th>Available Hours at Balance Date</th>
            <th>Hours Utilized</th>
            <th>Hours Remaining</th>
            <th>HR Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let application of employeeHistory">
            <td>{{application.conferenceTitle}}</td>
            <td>{{application.conferenceStartDate | date:'M/d/yy'}} - {{application.conferenceEndDate | date:'M/d/yy'}}</td>
            <td>{{application.levelLabel}}</td>
            <td>{{application.statusLabel}}</td>
            <td>{{application.utilizationStatusLabel || 'Pending'}}</td>
            <td>
              {{application.hoursPulled == null ? '-' : (application.hoursPulled | number:'1.2-2')}}
              <small class="d-block" *ngIf="application.hoursPulledDate">{{application.hoursPulledDate | date:'M/d/yy'}}</small>
            </td>
            <td>{{application.utilizedHours == null ? '-' : (application.utilizedHours | number:'1.2-2')}}</td>
            <td>{{application.hoursRemaining == null ? '-' : (application.hoursRemaining | number:'1.2-2')}}</td>
            <td>{{application.utilizationNotes || '-'}}</td>
          </tr>
          <tr *ngIf="!employeeHistory.length">
            <td colspan="9" class="text-muted">No conference history was found for this employee.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card" *ngIf="activeTab === 'report' && canReport">
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <h2>Conference Eligibility Report</h2>
        <p class="text-muted mb-0">Dates filter by conference start date. Role and department use each employee's current assignment.</p>
      </div>
      <div>
        <button type="button" class="btn btn-secondary btn-thin mr-1" [disabled]="exporting" (click)="exportReport('Csv')">CSV</button>
        <button type="button" class="btn btn-secondary btn-thin" [disabled]="exporting" (click)="exportReport('Excel')">Excel</button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-2">
        <label><b>Start date</b></label>
        <input type="date" class="form-control" [(ngModel)]="reportFilter.startDate" />
      </div>
      <div class="col-12 col-md-2">
        <label><b>End date</b></label>
        <input type="date" class="form-control" [(ngModel)]="reportFilter.endDate" />
      </div>
      <div class="col-12 col-md-2">
        <label><b>Role category</b></label>
        <select class="form-control" [(ngModel)]="reportFilter.roleCategoryID">
          <option [ngValue]="null">All</option>
          <option *ngFor="let option of report?.roleCategories" [ngValue]="option.value">{{option.label}}</option>
        </select>
      </div>
      <div class="col-12 col-md-2">
        <label><b>Department</b></label>
        <select class="form-control" [(ngModel)]="reportFilter.departmentID">
          <option [ngValue]="null">All</option>
          <option *ngFor="let option of report?.departments" [ngValue]="option.value">{{option.label}}</option>
        </select>
      </div>
      <div class="col-12 col-md-2">
        <label><b>Conference</b></label>
        <input class="form-control" [(ngModel)]="reportFilter.conference" />
      </div>
      <div class="col-12 col-md-2 d-flex align-items-end">
        <button type="button" class="btn btn-primary" [disabled]="reportLoading" (click)="loadReport()">Apply filters</button>
      </div>
      <div class="col-12 col-md-2 mt-2">
        <label><b>Level</b></label>
        <select class="form-control" [(ngModel)]="reportFilter.levelID">
          <option [ngValue]="null">All</option>
          <option *ngFor="let option of report?.levels" [ngValue]="option.value">{{option.label}}</option>
        </select>
      </div>
      <div class="col-12 col-md-2 mt-2">
        <label><b>Decision</b></label>
        <select class="form-control" [(ngModel)]="reportFilter.applicationStatusID">
          <option [ngValue]="null">Approved and Denied</option>
          <option *ngFor="let option of report?.applicationStatuses" [ngValue]="option.value">{{option.label}}</option>
        </select>
      </div>
      <div class="col-12 col-md-2 mt-2">
        <label><b>Utilization</b></label>
        <select class="form-control" [(ngModel)]="reportFilter.utilizationStatusID">
          <option [ngValue]="null">All</option>
          <option *ngFor="let option of report?.utilizationStatuses" [ngValue]="option.value">{{option.label}}</option>
        </select>
      </div>
    </div>
    <div class="text-center p-4" *ngIf="reportLoading"><i class="material-icons rotate text-muted">loop</i></div>
    <div class="table-responsive mt-3" *ngIf="!reportLoading">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Current Role / Department</th>
            <th>Conference</th>
            <th>Level</th>
            <th>Decision</th>
            <th>Utilization</th>
            <th>Reserved</th>
            <th>Available Hours at Balance Date</th>
            <th>Used</th>
            <th>Remaining</th>
            <th>HR Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of reportRows">
            <td>{{row.employeeName}}</td>
            <td>{{row.jobTitle || row.roleCategory || '-'}}<br /><small>{{row.departments || '-'}}</small></td>
            <td>{{row.conferenceTitle}}<br /><small>{{row.conferenceStartDate | date:'M/d/yy'}} - {{row.conferenceEndDate | date:'M/d/yy'}}</small></td>
            <td>{{row.levelLabel}}</td>
            <td>{{row.applicationStatusLabel}}</td>
            <td>{{row.utilizationStatusLabel}}</td>
            <td>{{row.reservedHours | number:'1.2-2'}}</td>
            <td>
              {{row.hoursPulled == null ? '-' : (row.hoursPulled | number:'1.2-2')}}
              <small class="d-block" *ngIf="row.hoursPulledDate">{{row.hoursPulledDate | date:'M/d/yy'}}</small>
            </td>
            <td>{{row.utilizedHours == null ? '-' : (row.utilizedHours | number:'1.2-2')}}</td>
            <td>{{row.hoursRemaining == null ? '-' : (row.hoursRemaining | number:'1.2-2')}}</td>
            <td>{{row.notes || '-'}}</td>
          </tr>
          <tr *ngIf="!reportRows.length">
            <td colspan="11" class="text-muted">No conference records match these filters.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<p-dialog header="Conference Application Review" [modal]="true" [style]="{width: '85vw'}"
          [(visible)]="showDetail">
  <ng-container *ngIf="selectedApplication">
    <div class="row">
      <div class="col-12 col-md-6">
        <h2>{{selectedApplication.conferenceTitle}}</h2>
        <div><b>Employee:</b> {{selectedApplication.employeeName}}</div>
        <div><b>Location:</b> {{selectedApplication.conferenceLocation || '-'}}</div>
        <div><b>Dates:</b> {{selectedApplication.conferenceStartDate | date:'M/d/yy'}} -
          {{selectedApplication.conferenceEndDate | date:'M/d/yy'}}</div>
        <div><b>Level:</b> {{selectedApplication.levelLabel}}</div>
        <div><b>Status:</b> {{selectedApplication.statusLabel}}</div>
      </div>
      <div class="col-12 col-md-6 mt-3 mt-md-0">
        <h3>Hours</h3>
        <div><b>Accrued:</b> {{selectedApplication.eligibilitySnapshot?.accruedHours | number:'1.2-2'}}</div>
        <div><b>Available at submission:</b> {{selectedApplication.eligibilitySnapshot?.availableHours | number:'1.2-2'}}</div>
        <div><b>Configured requirement:</b> {{selectedApplication.plannedHours | number:'1.2-2'}}</div>
        <div><b>Reserved:</b> {{selectedApplication.reservedHours | number:'1.2-2'}}</div>
      </div>
    </div>

    <div class="alert alert-warning mt-3" *ngIf="selectedApplication.isException">
      <b>Exception review required</b>
      <ul class="mb-0">
        <li *ngFor="let reason of selectedApplication.exceptionReasons">{{reason}}</li>
      </ul>
    </div>

    <h3 class="mt-4">Eligibility Snapshot</h3>
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Level</th>
            <th>Required Hours</th>
            <th>Result</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let level of selectedApplication.eligibilitySnapshot?.levelResults">
            <td>{{level.levelLabel}}</td>
            <td>{{level.requiredHours | number:'1.2-2'}}</td>
            <td>{{level.eligible ? 'Eligible' : 'Exception'}}</td>
            <td>{{level.reasons.join('; ') || 'All requirements met'}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 class="mt-4" *ngIf="selectedApplication.answers.length">Application Answers</h3>
    <div class="border-top pt-2 mt-2" *ngFor="let answer of selectedApplication.answers">
      <b>{{answer.questionPrompt}}</b>
      <div *ngIf="!answer.hasFile">{{answer.displayAnswer || '-'}}</div>
      <button type="button" *ngIf="answer.hasFile" class="btn btn-link p-0" (click)="openAnswerFile(answer)">
        <i class="fas fa-paperclip"></i> {{answer.fileName}}
      </button>
    </div>

    <h3 class="mt-4">Review History</h3>
    <div class="border-top pt-2 mt-2" *ngFor="let history of selectedApplication.statusHistory">
      <b>{{history.statusLabel}}</b> by {{history.changedByName}} on {{history.changedDate | date:'M/d/yy h:mm a'}}
      <span class="badge badge-warning ml-1" *ngIf="history.isOverride">Override</span>
      <div *ngIf="history.notes">{{history.notes}}</div>
    </div>

    <div class="border-top mt-4 pt-3" *ngIf="reviewActions.length">
      <h3>Review Action</h3>
      <select class="form-control" [(ngModel)]="selectedStatusID">
        <option [ngValue]="null">Select an action</option>
        <option *ngFor="let action of reviewActions" [ngValue]="action.statusID">{{action.label}}</option>
      </select>
      <label class="mt-3"><b>Reviewer Notes</b></label>
      <textarea class="form-control" rows="4" [(ngModel)]="notes"></textarea>
      <label class="d-block mt-3">
        <input type="checkbox" [(ngModel)]="isOverride" />
        Approve or advance as a policy exception
      </label>
      <button type="button" class="btn btn-primary mt-2" [disabled]="saving" (click)="submitReview()">
        Save Review
      </button>
    </div>
  </ng-container>
</p-dialog>

<p-dialog header="Post-Conference Outcome" [modal]="true" [style]="{width: '650px'}" [(visible)]="showUtilization">
  <ng-container *ngIf="selectedUtilizationApplication">
    <div><b>{{selectedUtilizationApplication.employeeName}}</b></div>
    <div class="mb-3">{{selectedUtilizationApplication.conferenceTitle}}</div>

    <label><b>Benefit outcome</b></label>
    <select class="form-control" [(ngModel)]="utilizationStatusID">
      <option [ngValue]="null">Select an outcome</option>
      <option *ngFor="let option of utilizationStatuses" [ngValue]="option.value">{{option.label}}</option>
    </select>

    <div class="row mt-3">
      <div class="col-12 col-md-6">
        <label><b>Balance date</b></label>
        <input type="date" class="form-control" [(ngModel)]="hoursPulledDate" (change)="loadHoursPulled()" />
      </div>
      <div class="col-12 col-md-6">
        <label><b>Available hours</b></label>
        <input class="form-control" [value]="loadingHoursPulled ? 'Calculating...' : (hoursPulled | number:'1.2-2')" readonly />
        <small class="text-muted">Conference-hours balance through the selected date, before this outcome and after prior deductions, adjustments, and other active reservations.</small>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-md-6">
        <label><b>Hours utilized for benefit</b></label>
        <input type="number" min="0" step="0.25" class="form-control" [(ngModel)]="utilizedHours"
               [disabled]="utilizationStatusID !== 1" />
      </div>
      <div class="col-12 col-md-6">
        <label><b>Hours remaining</b></label>
        <input class="form-control" [value]="hoursRemaining | number:'1.2-2'" readonly />
        <small class="text-muted">Available hours minus hours utilized; this may be negative.</small>
      </div>
    </div>

    <label class="mt-3"><b>Outcome date</b></label>
    <input type="date" class="form-control" [(ngModel)]="utilizationDate" />

    <label class="mt-3"><b>HR notes</b></label>
    <textarea class="form-control" rows="4" [(ngModel)]="utilizationNotes"></textarea>
    <small class="text-muted" *ngIf="selectedUtilizationApplication.utilizationStatusID">A correction note is required.</small>

    <div class="alert alert-info mt-3">
      Utilized releases {{selectedUtilizationApplication.reservedHours | number:'1.2-2'}} reserved hours and deducts the final utilized amount.
      Not Utilized releases the reservation without a deduction.
    </div>

    <button type="button" class="btn btn-primary" [disabled]="saving || loadingHoursPulled" (click)="saveUtilization()">
      Save Outcome
    </button>
  </ng-container>
</p-dialog>
